import React, {Fragment} from "react";

//import NoDataCSS from "./NoData.module.css";
import NoDataCSS from "./NoData.module.scss";
import {Button} from "antd";

const nodata = ({subHeading, btnText, image, setIsModalOpen}) => {
  return (
    <Fragment>
      <div className={NoDataCSS.no_data_container}>
        <div className={NoDataCSS.no_data_wrapper}>
          {image && <img src={image} alt="No Data"></img>}
          {subHeading && (
            <p className="font-16 line-height-26 weight-500 text-heading margin-top-25 margin-bottom-25">
              {subHeading}
            </p>
          )}
          {btnText && (
            <Button
              type="primary"
              htmlType="submit"
              className="btn-primary btn small-btn"
              onClick={() => setIsModalOpen(true, null)}
            >
              {btnText}
            </Button>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default nodata;
